import { z } from 'zod';
import { InvoiceSchema } from '../invoice';
import { pricePositiveSchema, priceSchema } from '../../validation';

export const transactionInvoiceSchema = InvoiceSchema.model
  .pick({
    _id: true,
    ref: true,
    title: true,
  })
  .extend({
    /** How much this invoice received from this transaction.
     *
     * - If positive number, the transaction increased the invoice by this amount.
     *
     * - If negative number, the transaction decreased the invoice by this amount.
     *
     */
    amount: priceSchema,
    /** this tracks the changes in the paid amount for an invoice `amount.paid`.
     *
     * - A positive number means in increase in the paid amount.
     * - A negative number means a decrease in the paid amount. This cloud happen int he case of a return or a total invoice was increased.
     * - Zero means nothing has changed.
     *
     */
    paidAmountChange: priceSchema,
    /** this tracks the changes in the remaining amount for an invoice `amount.remaining`.
     *
     * - A positive number means an increase in the remaining amount ... this cloud happen when there is a new amount added to the invoice
     * - A negative number means a decrease in the remaining amount. This cloud happen when there is new paid amount.
     * - Zero means nothing has changed.
     */
    remainingAmountChange: priceSchema,
    /**
     * this tracks the changes in the `unusedAmount` for an invoice.
     *
     * Again the `unusedAmount` is for mainly advance payments to track how much amount was spend/utilized/used for an advance payment invoice.
     *
     * - So a positive number here means an increase in the `unusedAmount` for an invoice, aka a new advance payment.
     * - a negative number means there is a decrease in the `unusedAmount` which means some of the amount has been utilized.
     * - Zero means nothing has changed.
     */
    unusedAmountChange: priceSchema,
    /**
     * this tracks actually the realized and paid amount.
     *
     * a realized paid amount is an amount that is actually paid in advance or in the spot and the service has been already delivered.
     *
     * This is VERY important to use for orders to indicate the actual paid amount ... when summed.
     *
     * Mostly this will be positive number. But in the case of a rejected or return transaction, this will be come a might be negative number.
     * So that when summed, it will give the actual paid amount for the delivered services.
     *
     */
    realizedPaidAmount: priceSchema,
    /**
     * this tracks the changes in invoice total amount `amount.total`.
     *
     * - a positive number means there is an increase in the invoice total amount.
     * - a negative number means there is a decrease in the invoice total amount due to discount or anything else.
     * - Zero means nothing has changed.
     */
    totalAmountChange: priceSchema,
    /**
     * this captures the invoice total amount AFTER the changes on invoice.
     *
     * This is NOT the total invoice change. This is total amount of the invoice AFTER the changes.
     *
     * This will most likely stay the same as long as there are no additional amounts has been added.
     */
    invoiceCurrentTotal: pricePositiveSchema,
  });
export type TransactionInvoice = z.infer<typeof transactionInvoiceSchema>;
